import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DishMachineOption } from '../../models/accountData';
import { GenericService } from '../../generic.service';
import { LandingService } from '../service/landing.service';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-machine-types',
    imports: [CommonModule],
    templateUrl: './machine-types.component.html',
    styleUrls: ['./machine-types.component.scss']
})
export class MachineTypesComponent {
  qrId: any;
  accountDetails: any = null;
  dishmachineOptions: DishMachineOption[] = [];
  unsupportedMachines: DishMachineOption[] = [];

  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  machineTypeMap: {
    [key: number]: { label: string; image: string; type: string };
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private genericService: GenericService,
    private landingService: LandingService,
    private crowdinService: CrowdinService,
  ) {
    this.machineTypeMap = this.landingService.getMachineTypeMap();
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
    this.qrId = this.route.snapshot.paramMap.get('id');
    this.accountDetails = this.genericService.getLocalStorage();
    this.filterDishMachines();
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  filterDishMachines(): void {
    this.dishmachineOptions = [];
    this.unsupportedMachines = [];

    if (this.accountDetails?.devices) {
      this.accountDetails.devices.forEach((device: any) => {
        const machineType = device.MachineType;
        const machineConfig = this.machineTypeMap[machineType];

        if (machineConfig) {
          this.dishmachineOptions.push({
            value: machineConfig.label,
            label: machineConfig.label,
            image: machineConfig.image,
            type: machineConfig.type,
            deviceType: machineType,
          });
        }
      });

      Object.keys(this.machineTypeMap).forEach((key) => {
        const machineType = Number(key);
        const isSupported = this.accountDetails.devices.some(
          (d: any) => d.MachineType === machineType,
        );
        if (!isSupported) {
          const config = this.machineTypeMap[machineType];
          this.unsupportedMachines.push({
            value: config.label,
            label: config.label,
            image: config.image,
            type: config.type,
            deviceType: machineType,
          });
        }
      });
    }
  }

  onMachineSelect(machine: DishMachineOption) {
    const localData = this.genericService.getLocalStorage();
    const accountNumber = localData?.accountNumber;
    if (!accountNumber) {
      return;
    }
    this.genericService.setLocalStorage({ selectedMachineType: machine.value });
    this.router.navigate(['/troubleshoot', accountNumber]);
  }
}
